export default {
    "name": "HomeTransferOrderDefaults",
    "kind": "HoudiniQuery",
    "hash": "7c500b5e91feddddfae71cfc52b39adaf1105ab0daca0304e22b6551df5fa0f9",

    "raw": `query HomeTransferOrderDefaults {
  settingValues {
    home {
      defaultTransferOrderHistoryDateRange
    }
  }
}
`,

    "rootType": "Query",
    "stripVariables": [],

    "selection": {
        "fields": {
            "settingValues": {
                "type": "SettingValues",
                "keyRaw": "settingValues",

                "selection": {
                    "fields": {
                        "home": {
                            "type": "HomeSettingValues",
                            "keyRaw": "home",

                            "selection": {
                                "fields": {
                                    "defaultTransferOrderHistoryDateRange": {
                                        "type": "String",
                                        "keyRaw": "defaultTransferOrderHistoryDateRange",
                                        "visible": true
                                    }
                                }
                            },

                            "visible": true
                        }
                    }
                },

                "visible": true
            }
        }
    },

    "pluginData": {
        "houdini-svelte": {}
    },

    "policy": "NetworkOnly",
    "partial": false
};

"HoudiniHash=b6f0520939f117eb3c06bf58b077803f2889e4e2bd632ecf3bb6e4924e36afd5";